import React from 'react';

const TasksIcon = (props) => {
  let { 
    height, 
    width, 
    iconColor,
  } = props;
    
  return (
    <svg 
      width={width ? width : '16px'} 
      height={height ? height : '19px'} 
      viewBox="0 0 16 19" 
      version="1.1" 
      xmlns="http://www.w3.org/2000/svg" 
      xmlnsXlink="http://www.w3.org/1999/xlink">
      <title>Tasks</title>
      <g id="V.4-Design-Change" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="company-filter--copy-2" transform="translate(-1013.000000, -31.000000)" fillRule="nonzero" fill={iconColor}>
          <path 
            d="M1028.01,50 L1013.95,50 C1013.4256,50 1013,49.5744 1013,49.05 L1013,34.23 C1013,33.7056 
            1013.4256,33.28 1013.95,33.28 L1016.1084,33.28 C1016.268,32.8392 1016.686,32.52 1017.18,32.52 
            L1019.08,32.52 L1019.08,32.14 C1019.08,31.5092 1019.5892,31 1020.22,31 L1021.74,31 C1022.3708,31 
            1022.88,31.5092 1022.88,32.14 L1022.88,32.52 L1024.78,32.52 C1025.274,32.52 1025.6996,32.8392 
            1025.8516,33.28 L1028.01,33.28 C1028.5344,33.28 1028.96,33.7056 1028.96,34.23 L1028.96,49.05 
            C1028.96,49.5744 1028.5344,50 1028.01,50 Z M1013.95,34.04 C1013.8512,34.04 1013.76,34.1312 
            1013.76,34.23 L1013.76,49.05 C1013.76,49.1488 1013.8512,49.24 1013.95,49.24 L1028.01,49.24 
            C1028.1088,49.24 1028.2,49.1488 1028.2,49.05 L1028.2,34.23 C1028.2,34.1312 1028.1088,34.04 
            1028.01,34.04 L1025.92,34.04 L1025.92,35.18 C1025.92,35.3928 1025.7528,35.56 1025.54,35.56 
            L1016.42,35.56 C1016.2072,35.56 1016.04,35.3928 1016.04,35.18 L1016.04,34.04 L1013.95,34.04 
            Z M1016.8,34.8 L1025.16,34.8 L1025.16,33.66 C1025.16,33.4472 1024.9928,33.28 1024.78,33.28 
            L1022.5,33.28 C1022.2872,33.28 1022.12,33.1128 1022.12,32.9 L1022.12,32.14 C1022.12,31.9272 
            1021.9528,31.76 1021.74,31.76 L1020.22,31.76 C1020.0072,31.76 1019.84,31.9272 1019.84,32.14 
            L1019.84,32.9 C1019.84,33.1128 1019.6728,33.28 1019.46,33.28 L1017.18,33.28 C1016.9672,33.28 
            1016.8,33.4472 1016.8,33.66 L1016.8,34.8 Z M1019.8248,44.3 C1019.726,44.3 1019.6272,44.262 
            1019.5588,44.186 L1016.9064,41.5336 L1017.446,40.994 L1019.8248,43.3728 L1024.8864,38.3112 
            L1025.426,38.8508 L1020.0984,44.1784 C1020.0148,44.262 1019.916,44.3 1019.8248,44.3 Z" 
            id="Checkmark_Clipboard"/>
        </g>
      </g>
    </svg>
  );
};

export default TasksIcon;



// WEBPACK FOOTER //
// ./src/components/Iconoclast/TasksIcon/index.js